import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const useCartStore = create(
  persist(
    (set, get) => ({
      items: [],
      
      addToCart: (product, size) => {
        const items = get().items;
        const existingItemIndex = items.findIndex(
          item => item.id === product.id && item.selectedSize === size
        );
        
        if (existingItemIndex > -1) {
          const newItems = [...items];
          newItems[existingItemIndex].quantity += 1;
          set({ items: newItems });
        } else {
          set({
            items: [
              ...items,
              {
                ...product,
                selectedSize: size,
                quantity: 1,
                itemPrice: product.price[size]
              }
            ]
          });
        }
      },
      
      removeFromCart: (productId, size) => {
        set({
          items: get().items.filter(
            item => !(item.id === productId && item.selectedSize === size)
          )
        });
      },
      
      updateQuantity: (productId, size, quantity) => {
        if (quantity <= 0) {
          get().removeFromCart(productId, size);
          return;
        }
        
        const items = get().items;
        const itemIndex = items.findIndex(
          item => item.id === productId && item.selectedSize === size
        );
        
        if (itemIndex > -1) {
          const newItems = [...items];
          newItems[itemIndex].quantity = quantity;
          set({ items: newItems });
        }
      },
      
      clearCart: () => set({ items: [] }),
      
      getTotal: () => {
        return get().items.reduce(
          (total, item) => total + item.itemPrice * item.quantity,
          0
        );
      },
      
      getItemCount: () => {
        return get().items.reduce((total, item) => total + item.quantity, 0);
      }
    }),
    {
      name: 'rickys-bees-cart'
    }
  )
);

export default useCartStore;
